import CustomerContactsCreate from './CustomerContactsCreate';

export default CustomerContactsCreate;
